import { VendorView } from '@trackly/shared';

// ── Pure transform helpers consumed only by vendorSlice ────────────

export interface VendorState {
  currentVendor: VendorView | null;
  selectedVendorId: string | null;
  isEdited: boolean;
  editedFields: string[];
  filters: {
    searchTerm: string;
  };
}

export const addEditedField = (state: VendorState, fieldName: string) => {
  if (!state.editedFields.includes(fieldName)) {
    state.editedFields.push(fieldName);
  }
  state.isEdited = true;
};

export const applyVendorUpdate = (state: VendorState, updates: Partial<VendorView>) => {
  if (!state.currentVendor) return;
  state.currentVendor = { ...state.currentVendor, ...updates };
  Object.keys(updates).forEach(field => addEditedField(state, field));
};

export const applyIdentificationUpdate = (
  state: VendorState,
  updates: { companyName?: string; dba?: string; status?: string },
) => {
  if (!state.currentVendor) return;
  if (updates.companyName !== undefined) state.currentVendor.companyName = updates.companyName;
  if (updates.dba !== undefined) state.currentVendor.dba = updates.dba;
  if (updates.status !== undefined) state.currentVendor.status = updates.status;
  addEditedField(state, 'identification');
};

export const applyContactUpdate = (
  state: VendorState,
  updates: {
    primaryContactName?: string;
    primaryPhone?: string;
    primaryEmail?: string;
    secondaryContactName?: string;
    secondaryPhone?: string;
    secondaryEmail?: string;
    website?: string;
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  },
) => {
  if (!state.currentVendor) return;
  if (updates.primaryContactName !== undefined) state.currentVendor.primaryContactName = updates.primaryContactName;
  if (updates.primaryPhone !== undefined) state.currentVendor.primaryPhone = updates.primaryPhone;
  if (updates.primaryEmail !== undefined) state.currentVendor.primaryEmail = updates.primaryEmail;
  if (updates.secondaryContactName !== undefined) state.currentVendor.secondaryContactName = updates.secondaryContactName;
  if (updates.secondaryPhone !== undefined) state.currentVendor.secondaryPhone = updates.secondaryPhone;
  if (updates.secondaryEmail !== undefined) state.currentVendor.secondaryEmail = updates.secondaryEmail;
  if (updates.website !== undefined) state.currentVendor.website = updates.website;
  if (updates.street !== undefined) state.currentVendor.street = updates.street;
  if (updates.city !== undefined) state.currentVendor.city = updates.city;
  if (updates.state !== undefined) state.currentVendor.state = updates.state;
  if (updates.zip !== undefined) state.currentVendor.zip = updates.zip;
  addEditedField(state, 'contact');
};

export const resetEditState = (state: VendorState) => {
  state.isEdited = false;
  state.editedFields = [];
};

export const clearVendorState = (state: VendorState) => {
  state.currentVendor = null;
  state.selectedVendorId = null;
  state.isEdited = false;
  state.editedFields = [];
};
